<template>
  <div>
    <!-- 顶部导航区 -->
    <div class="flex" style="justify-content: space-between;">
      <ul class="menu">
        <li class="title">动态报告</li>
        <li class="menu-item sub-item subtitle">项目概述</li>
      </ul>

      <div class="operate_btns" v-if="store.ticket && store.app_id && store.task_id">
        <!-- 使用说明 -->
        <el-button size="large" @click="openHelp" class="function_btn">
          <!--  <img src="./img/operate_1.png" alt=""> -->
          <span>使用说明</span>
        </el-button>

        <!-- 报告配置 -->
        <el-popover v-if="props.raw_data.is_report_generation" placement="bottom" :width="340" trigger="click"
          popper-class="report_config_pop">
          <div>
            <el-form class="custom_form" label-position="top">
              <el-form-item label="报告类型">
                <el-select v-model="category_name" placeholder="请选择" size="large" clearable filterable
                  @change="handleCategoryChange" style="width: 100%">
                  <el-option v-for="item in props.raw_data.report_tree.category" :key="item.name" :label="item.title"
                    :value="item.name" />
                </el-select>
              </el-form-item>
            </el-form>

            <div class="text-center">
              <el-button type="primary" size="large"
                style="width: 207px;height: 52px;border-radius: 40px;font-size: 16px;" :loading="loading.save"
                @click="saveConfig">保存</el-button>
            </div>
          </div>

          <template #reference>
            <el-button type="primary" size="large" class="function_btn">
              <!--  <img src="./img/operate_2.png" alt=""> -->
              <span>报告配置</span>
            </el-button>
          </template>
        </el-popover>

        <!-- 报告生成 v-if="props.raw_data.is_report_generation" -->
        <el-popover v-if="false" placement="bottom" :width="340" trigger="click" popper-class="report_config_pop">
          <div>
            <el-form class="custom_form" label-position="top" label-width="80px">
              <el-form-item label="支持格式">
                <el-select v-model="handle_modes" multiple placeholder="请选择" size="large">
                  <el-option v-for="e in file_types" :key="e" :label="e" :value="e" />
                </el-select>
              </el-form-item>

              <el-form-item label="是否需要结果文件">
                <el-switch v-model="is_need_result" active-color="#13ce66" inactive-color="#e5e5e5" />
              </el-form-item>
            </el-form>

            <div class="text-center">
              <el-button type="primary" size="large" :loading="loading.generate"
                style="width: 207px;height: 52px;border-radius: 40px;font-size: 16px;"
                @click="generateReport">确定</el-button>
            </div>
          </div>

          <template #reference>
            <el-button type="primary" size="large" class="function_btn">
              <!-- <img src="./img/operate_3.png" alt=""> -->
              <span>报告生成</span>
            </el-button>
          </template>
        </el-popover>

        <!-- 结果下载 -->
        <el-popover placement="bottom" :width="340" trigger="click" popper-class="report_config_pop">
          <div>
            <el-form class="custom_form" label-position="top">
              <el-form-item label="下载格式">
                <el-select v-model="handle_mode" clearable placeholder="请选择" size="large" style="width: 100%;">
                  <el-option v-for="e in file_types" :key="e" :label="e" :value="e" />
                </el-select>
              </el-form-item>

              <el-form-item label="是否需要结果文件" v-if="handle_mode === 'html'">
                <el-switch v-model="is_need_result" active-color="#13ce66" inactive-color="#e5e5e5" />
              </el-form-item>
            </el-form>

            <div class="text-center">
              <el-button type="primary" size="large" :loading="loading.download"
                style="width: 207px;height: 52px;border-radius: 40px;font-size: 16px;"
                @click="downloadHandle">确定</el-button>
            </div>
          </div>

          <template #reference>
            <el-button type="primary" size="large" class="function_btn">
              <!-- <img src="./img/operate_4.png" alt=""> -->
              <span>结果下载</span>
            </el-button>
          </template>
        </el-popover>
      </div>
    </div>

    <!-- 分隔线 -->
    <el-divider style="margin-top: 46px;margin-bottom: 40px;" />

    <!-- 项目信息 -->
    <div class="container">
      <div class="flex-column item" v-for="item in info_list" :key="item.key">
        <!-- <div class="item_icon"><img :src="item.icon" alt=""></div> -->
        <div class="ellipsis item_title">{{ item.name }}</div>
        <div class="ellipsis item_value">{{ getItemValue(item.key) }}</div>
      </div>
    </div>

    <!-- 使用说明弹窗 -->
    <el-dialog v-model="dialogVisible" title="使用说明" width="1200" top="50px"
      :before-close="() => (dialogVisible = false)">
      <div v-if="help_doc_info" v-html="help_doc_info" class="help_doc_container" />
      <el-empty v-else description="暂无数据" />
      <template #footer>
        <div class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false">关闭</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
  import { ref, watch, onMounted, defineEmits, defineProps } from "vue";
  import { ElMessage } from "element-plus";
  import { marked } from "marked";
  import { useStore } from "@/Store/index.js";
  import { useTaskStore, useFormStore } from "@/Store/task.js";
  import { save_report_config } from "@/api/index.js";

  // ======= Props & Emits =======
  const emit = defineEmits(["switchConfig", "generateReport", "downloadHandle"]);
  const props = defineProps({
    categoryName: String,
    raw_data: Object,
    task_info: Object,
  });

  // ======= Store =======
  const store = useStore();
  const taskStore = useTaskStore();
  useFormStore(); // 仅初始化

  // ======= State =======
  const category_name = ref(null);
  const handle_mode = ref("html");
  const handle_modes = ref(["html"]);
  const file_types = ref(["html", "docx", "pdf"]);
  const is_need_result = ref(true);
  const loading = ref({ save: false, generate: false, download: false });
  const dialogVisible = ref(false);
  const help_doc_info = ref(null);

  // ======= 基础信息配置 =======
  const info_list = ref([
    /*  { name: "项目编号", icon: require("./img/info_1.png"), key: "project_no" },
     { name: "项目名称", icon: require("./img/info_2.png"), key: "project_name" },
     { name: "单位", icon: require("./img/info_3.png"), key: "customer_unit" },
     { name: "客户名称", icon: require("./img/info_4.png"), key: "customer_name" }, */
    { name: "任务名称", icon: require("./img/info_5.png"), key: "name" },
    { name: "任务版本", icon: require("./img/info_6.png"), key: "process_version" },
    /* { name: "报告审核人", icon: require("./img/info_7.png"), key: "reviewer_info" }, */
    { name: "报告日期", icon: require("./img/info_8.png"), key: "report_date" },
  ]);

  // ======= 方法 =======

  // 切换报告类型
  const handleCategoryChange = (val) => emit("switchConfig", val);

  // 格式化日期
  const formatDate = (dateStr) => (dateStr ? dateStr.split(" ")[0] : "");

  // 获取显示字段
  const getItemValue = (key) => {
    const info = props.task_info || {};
    const proj = info.project_info || {};

    const map = {
      project_no: proj.project_no,
      customer_unit: proj.customer_unit,
      customer_name: proj.customer_name,
      project_name: proj.project_name,
      name: info.name,
      process_version: info.process_version,
      reviewer_info: info.reviewer_info,
      report_date: formatDate(info.report_date),
    };

    return map[key] || "暂无";
  };

  // 防抖防连点
  let lastClickTime = { generate: 0, download: 0 };

  // 报告生成
  const generateReport = () => {
    const now = Date.now();
    if (now - lastClickTime.generate < 5000) return;
    lastClickTime.generate = now;

    emit("generateReport", {
      category_name: category_name.value,
      handle_type: "generate",
      handle_mode: handle_mode.value,
      is_need_result: is_need_result.value,
    });
  };

  // 报告下载
  const downloadHandle = () => {
    const now = Date.now();
    if (now - lastClickTime.download < 5000) return;
    lastClickTime.download = now;

    emit("downloadHandle", {
      category_name: category_name.value,
      handle_type: "download",
      handle_mode: handle_mode.value,
      /* v-if="handle_mode === 'html'" */
      is_need_result: handle_mode.value === 'html' ? is_need_result.value : false,
    });
  };

  // 打开帮助
  const openHelp = () => {
    help_doc_info.value = marked.parse(taskStore.template_config?.help_doc_info || "");
    dialogVisible.value = true;
  };

  // 保存配置
  const saveConfig = async () => {
    const params = {
      category_name: category_name.value,
      task_id: store.task_id,
    };
    loading.value.save = true;
    try {
      const result = await save_report_config(params);
      if (result.code === 200) ElMessage.success(result.message || "保存成功");
    } finally {
      loading.value.save = false;
    }
  };

  // ======= 监听 & 生命周期 =======
  watch(
    () => props.categoryName,
    (val) => (category_name.value = val || null),
    { immediate: true }
  );

  onMounted(() => {
    category_name.value = props.categoryName;
  });
</script>

<style lang="scss" scoped>
  .menu {
    list-style: none;
    padding-left: 20px;
  }

  .title {
    font-size: 28px;
    font-weight: 500;
  }

  .subtitle {
    font-size: 20px;
    color: #757d8a;
    margin-top: 15px;
  }

  .menu-item {
    position: relative;
    padding-left: 25px;
    line-height: 24px;
  }

  .sub-item::before {
    content: "";
    position: absolute;
    left: 5px;
    top: 0;
    width: 16px;
    height: 22px;
    border-left: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    transform: translateY(-50%);
  }

  .container {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
  }

  .item {
    width: calc(25% - 20px);
    background: #fafafa;
    border-radius: 8px;
    padding: 20px 24px;
    font-size: 20px;
    box-sizing: border-box;
  }

  .item_title {
    font-size: 16px;
    color: #333;
  }

  .item_value {
    font-size: 18px;
    font-weight: 500;
  }

  .operate_btns .el-button {
    padding: 0 30px;
    border-radius: 30px;
  }

  @media screen and (max-width: 1400px) {
    .title {
      font-size: 20px;
    }

    .subtitle {
      font-size: 14px;
    }

    .function_btn {
      height: 30px;
      padding: 0 10px !important;
      font-size: 12px;

      img {
        width: 15px;
        height: 15px;
      }
    }

    .item {
      padding: 10px;

      .item_icon img {
        width: 16px;
      }

      .item_title {
        font-size: 12px;
      }

      .item_value {
        font-size: 14px;
      }
    }
  }
</style>

<style>
  .report_config_pop {
    padding: 40px !important;
  }

  .help_doc_container {
    max-height: 800px;
    overflow-y: auto;
    min-height: 500px;
  }

  .text-center {
    text-align: center;
  }
</style>